import '@cian/base-css/base.css';
import '@cian/components/lib/index.css';

import '@cian/base-css/lato.css';

import './bundles/common/legacy/components/index.css';
import './bundles/elements/legacy/components/index.css';

import './bundles/app_banner/index';
import './bundles/business_shopping_centers_landing/index';
import './bundles/offer/index';

import initAdFox from './bundles/adfox/index';
import initAgentBonusTooltip from './bundles/agent_bonus/index';
import initBusinessShoppingCentersSerp from './bundles/business_shopping_centers_serp/index';
import initCallNowPopup, { makeCallNowApiGlobal } from './bundles/call_now/index';
import initCallbackPopup from './bundles/callback_popup';
import initCommercialClaims from './bundles/commercial_claims/index';
import initialHonestWork from './bundles/honest_work/index';
import initMainPage from './bundles/mainpage/index';
import initOffer from './bundles/offer/index';
import initPopup from './bundles/popup/index';
import initPriceChangeSubscription from './bundles/price_change_subscription/index';
import initPrintOfferButton from './bundles/print/index';
import initSelfSimilarObjects from './bundles/self_similar_objects/index';
import initSentry from './bundles/sentry/index';
import initSerp from './bundles/serp/index';
import initSimilarObjectsSopr from './bundles/similar_objects_sopr/index';
import initSubscription from './bundles/subscription/index';
import initUserClaims from './bundles/user_claims/index';

import store from './di/store';

import throttle = require('lodash/throttle');

initSentry();
initAdFox();
initMainPage();
initPopup(store);
initUserClaims();
initPriceChangeSubscription();
initBusinessShoppingCentersSerp();
initCommercialClaims();
initCallNowPopup();
makeCallNowApiGlobal();
initSerp();
initSubscription();
initOffer();
initPrintOfferButton();
initSelfSimilarObjects();
initAgentBonusTooltip();
initSimilarObjectsSopr();
initCallbackPopup();
initialHonestWork();

// tslint:disable-next-line:no-any
(window as any).lodashThrottle = throttle;



// WEBPACK FOOTER //
// ./src/index.ts